import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface QuickTileProps {
  to: string;
  label: string;
  sub?: string;
  icon: LucideIcon;
  accent?: 'primary' | 'accent' | 'warning' | 'info' | 'success' | 'neutral';
}

const ACCENT_CLASSES: Record<NonNullable<QuickTileProps['accent']>, string> = {
  primary: 'text-[#00A871] bg-emerald-50',
  accent: 'text-amber-700 bg-amber-50',
  warning: 'text-orange-700 bg-orange-50',
  info: 'text-sky-700 bg-sky-50',
  success: 'text-emerald-700 bg-emerald-50',
  neutral: 'text-slate-700 bg-slate-100',
};

export function QuickTile({ to, label, sub, icon: Icon, accent = 'neutral' }: QuickTileProps) {
  return (
    <Link
      to={to}
      className="group flex items-start gap-3 rounded-xl bg-slate-50 hover:bg-slate-100 p-4 transition-colors"
    >
      <span
        className={`inline-flex w-10 h-10 items-center justify-center rounded-xl ${ACCENT_CLASSES[accent]}`}
      >
        <Icon className="w-5 h-5" strokeWidth={2} aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-semibold text-slate-900 truncate">{label}</div>
        {sub && (
          <div className="text-[11px] text-slate-500 mt-0.5 truncate">{sub}</div>
        )}
      </div>
    </Link>
  );
}
